// What a Supabase email link says about itself, read from the URL hash. U0.6.
//
// An invite or a password-recovery link lands on the app with
// `#access_token=…&type=invite` (or `recovery`), and supabase-js turns that
// into a session on its own — which is exactly the problem: a session means
// the app draws Today, for a person who has no password yet. The hash is the
// only place that says so, and supabase-js clears it once it has read it, so
// `auth.tsx` reads it once, at load, through this.
//
// Pure and import-free so the Worker's suite — the only one `npm run check`
// gates on — can load it.

export interface AuthLink {
  /** `invite` or `recovery` when the hash carries a token of that type. */
  kind: 'invite' | 'recovery' | null
  /** Supabase's refusal, in words — an expired or already-used link arrives as
   *  `#error=access_denied&error_code=otp_expired&…` and no session at all. */
  error: string | null
}

export function authLinkFromHash(hash: string): AuthLink {
  // The app's own routes are `#/today` and the like: no `=`, parsed to nothing.
  const p = new URLSearchParams(hash.replace(/^#/, ''))
  const type = p.get('type')
  if (p.get('access_token') && (type === 'invite' || type === 'recovery')) {
    return { kind: type, error: null }
  }
  if (p.get('error') || p.get('error_code')) {
    return {
      kind: null,
      error: p.get('error_code') === 'otp_expired'
        ? 'That link has expired or was already used. Ask for a new one.'
        : p.get('error_description') ?? 'That link did not work. Ask for a new one.',
    }
  }
  return { kind: null, error: null }
}
